module.exports = __webpack_public_path__ + "img/excavating_machinery-icon4.9b6c372f.png";